import {IController, IModule, IOnChangesObject} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";

const css = require('./fakturainformasjon.scss');

export class OrgFakturainformasjonKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmAvtaleFakturainformasjon', {
                bindings: {faktureringsinformasjon: '<'},
                controller: OrgFakturainformasjonKontroller.forInjisering(),
                template: require('./fakturainformasjon.html')
            });
    }

    static forInjisering() {
        return [
            OrgFakturainformasjonKontroller
        ]
    }

    constructor() {
    }

    faktureringsinformasjon: l.FaktureringsinformasjonModell; //settes via bindings/$onChanges

    $onChanges(changes: IOnChangesObject): void {
    }

}
